import { render, staticRenderFns } from "./UiFormNotice.vue?vue&type=template&id=f518534a&scoped=true"
import script from "./UiFormNotice.vue?vue&type=script&lang=js"
export * from "./UiFormNotice.vue?vue&type=script&lang=js"
import style0 from "./UiFormNotice.vue?vue&type=style&index=0&id=f518534a&prod&lang=scss&scoped=true"
import style1 from "./UiFormNotice.vue?vue&type=style&index=1&id=f518534a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f518534a",
  null
  
)

export default component.exports